import { Trans } from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import {validateVinRegEx} from "../Shared/FormField";
import { isArray } from "lodash";
import {addressConfigB2b} from "./components/address_b2b";

export const hasProducts = (products) => {
    // In the case of array fields (e. g. in SelfRepairProductSelect or SelfRepairCheckout)
    // products is not an object like ({ [id]: [amount] }) but an array of products like [{id, amount}, ...]
    if (isArray(products)) {
        return products.filter(item => item && Number(item.amount ?? 0) > 0).length > 0;
    }

    return products && Object.values(products).filter(item => item && item !== "0").length > 0;
}

export const orderEntryConfigEnfore = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "description": <Trans i18nKey={"orderEntry.description"}>Your device is not behaving as you expect? <a href={"https://b2x.com/"} title={'B2X'} target={'_blank'}>B2X</a> support you from here to provide a solution quickly. Please complete the form below and we will get back to you to resolve the situation.</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "requesttypeselect"
                }
            ]
        },
        {
            "id": "product_selection",
            "fields": [
                {
                    "size": "full",
                    "component": "productselectdynamic"
                },
            ],
            "conditionFunction": values => values.requesttype
        },
        {
            "heading": <Trans i18nKey="orderEntry.shipmentRecordType">Shipment method</Trans>,
            "description": <Trans i18nKey="orderEntry.shipmentRecordType.description">Please select a prefered shipment method.</Trans>,
            "id": "shipment_record_type",
            "fields": [
                {
                    "name": "shipment_record_type",
                    "label": <Trans i18nKey="orderEntry.shipmentRecordType">Shipment method</Trans>,
                    "placeholder": <Trans i18nKey="orderEntry.shipmentRecordType.placeholder">Please choose</Trans>,
                    "size": "full",
                    "type": "select",
                    "required": true,
                    "options": [
                        {
                            "value": "UPS Standard",
                            "label": <Trans i18nKey="orderEntry.shipmentRecordType.UpsStandard">UPS Standard</Trans>
                        },
                        {
                            "value": "Pallet shipping",
                            "label": <Trans i18nKey="orderEntry.shipmentRecordType.PalletShipping">Pallet shipping</Trans>
                        }
                    ],
                }
            ],
            "conditionFunction": (values, orderEntryState) => !!values.requesttype && hasProducts(values.products)
        },
        {
            "heading": <Trans i18nKey="orderEntry.addressContact">Address & contact information</Trans>,
            "description": <Trans i18nKey="orderEntry.addressContact.description"></Trans>,
            "fields": [
                ...addressConfigB2b,
            ],
            "conditionFunction": (values, orderEntryState) => !!values.requesttype && hasProducts(values.products) && values.shipment_record_type
        },
        {
            "heading": <Trans i18nKey="orderEntry.customerReference.label">Customer references</Trans>,
            "fields": [
                {
                    "name": "external_customer_number",
                    "label": <Trans i18nKey="orderEntry.externalCustomerNumber.label">External customer number</Trans>,
                    "size": "full",
                    "required": true,
                },
                {
                    "name": "customer_reference",
                    "label": <Trans i18nKey="orderEntry.customerReference.label">Customer reference</Trans>,
                    "size": "full",
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                const validAddress = values.name && values.city && values.street && values.zip && values.country_id;

                return !!values.requesttype && hasProducts(values.products) && values.shipment_record_type && !!validAddress;
            }
        },
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, orderEntryState) => {
                        const validAddress = values.name && values.city && values.street && values.zip && values.country_id;

                        return !!values.requesttype && hasProducts(values.products) && values.shipment_record_type && !!validAddress;
                    }
                }
            ]
        }
    ]
}
